import Box from '@sendsprint/ui-react/dist/components/Box';
import Container from '@src/components/container';
import { useAccount } from '@src/contexts';
import { Path } from '@src/navigations/routes';
import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Aside from './components/aside';
import Header from './components/header';
import ReferralModal from '@src/components/referralModal';

const countryToCurrency: Record<string, string> = {
  US: '$',
  GB: '£',
  CA: '$'
};

const DashboardLayout = () => {
  const { isLoggedIn, user, userAddress } = useAccount();
  const [isRestricted, setIsRestricted] = useState<boolean>(!!user?.referralCode);

  const currencyCode = userAddress?.country
    ? countryToCurrency[userAddress.country] || 'Unknown'
    : 'Unknown';

  if (!isLoggedIn) {
    return <Navigate to={Path.Login} replace />;
  }

  return (
    <>
      <Box style={{ backgroundColor: '#F6F8FA' }} className="ss-min-h-screen ss-pb-6">
        <Header />
        <Box className="">
          {/* {user?.referralCode && (
            <Box className="ss-bg-[#16342E] ss-text-center ss-mt-6 ss-text-white ss-py-4">
              💰 Send {currencyCode}150 & Get {currencyCode}10 Off!
            </Box>
          )} */}
          <Container className="ss-flex ss-gap-8 ss-mt-6">
            <Aside />
            <Box as="main" className="ss-flex-1">
              <Outlet />
            </Box>
            {/* <ReferralModal
              isOpen={isRestricted}
              handleClose={() => {
                setIsRestricted(false);
              }}
            /> */}
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default DashboardLayout;
